import {hexMD5} from "./md5";
function randomString(e) {
  e = e || 32;
  var t = "abcdefghijklmnopqrstuvwxyz1234567890",
    a = t.length,
    n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n
}

function hashCode(strKey) {
  var hash = 0;
  if(!isNull(strKey))
  {
    for (var i = 0; i < strKey.length; i++)
    {
      hash = hash * 31 + strKey.charCodeAt(i);
      hash = intValue(hash);
    }
  }
  return hash;
}
function isNull(str){
  return str == null || str.value == "";
}
function intValue(num) {
  var MAX_VALUE = 0x7fffffff;
  var MIN_VALUE = -0x80000000;
  if(num > MAX_VALUE || num < MIN_VALUE)
  {
    return num &= 0xFFFFFFFF;
  }
  return num;
}

export function getSIgn(data){
  let uid = randomString();
  // let newUid = uid[0] + uid[0] + uid[3] + uid[16] + uid[31] + uid[26] + uid[19] + uid[29];
  let newUid = uid[1] + uid[7] + uid[31] + uid[5] + uid[31] + uid[8] + uid[19] + uid[11];
  let param_str = '';
  let cliplabSign = '';
  if (data) {
    let param_obj = data;
    let newData = [];
    for (let key in param_obj) {
      newData.push(key)
    }
    let params_sort = newData.sort();
    for (let name in params_sort) {
      param_str += param_obj[params_sort[name]]
    }
    cliplabSign = hexMD5((hashCode(newUid)^(hashCode(newUid)>>7)) + hexMD5(param_str))
    // cliplabSign = hexMD5(newUid + hexMD5(param_str))
  } else {
    // cliplabSign = hexMD5(newUid)
    cliplabSign = hexMD5(hashCode(newUid)^(hashCode(newUid)>>7))
  }
  let obj={
    key:uid,
    cliplabSign:cliplabSign
  };
  return obj;
}
